import React, {} from 'react';


interface IllegalMoveCommentPopUpProps {
  isOpen: boolean;
  onClose: () => void;
  show_comment: string;
}

const IllegalMoveCommentPopUp: React.FC<IllegalMoveCommentPopUpProps> = ({ 
  isOpen,
  onClose, 
  show_comment
}) =>{


  if (isOpen) return (
    <div className="pmodal">
        <div className="overlay">
          <div className="modal">
            <h5 className="red-text mtitle">The final score has been reduced by 3 points per judge.</h5>
            <div className="mbody">
              <h5>Illegal move notes:</h5>
              <p className="comment_sec">{show_comment}</p>
              <div className="align_center">
                  <button className="p-close-button" onClick={onClose}>Close</button>
              </div>
              <button className="closeButton" onClick={onClose}>X</button>
            </div>
          </div>
      </div>
    </div>
  );
  else return ('');
}

export default IllegalMoveCommentPopUp;